import { render, staticRenderFns } from "./MyInspections.vue?vue&type=template&id=8169196c&scoped=true&"
import script from "./MyInspections.vue?vue&type=script&lang=js&"
export * from "./MyInspections.vue?vue&type=script&lang=js&"
import style0 from "./MyInspections.vue?vue&type=style&index=0&id=8169196c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8169196c",
  null
  
)

export default component.exports